import React from 'react';
import {ProfileHub} from 'features/profile';

export function ProfilePage(): React.ReactElement {
	return <ProfileHub />;
}
